export const chlorophyllSplashScreen = true
export const facebookTracking = false
